/**
 * Created by yihong on 8/30/17.
 */
export default function setTitle(title) {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
    if (/imgo/i.test(window.navigator.userAgent)) {
      setTimeout(() => {
        document.title = title;
        const iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.src = 'https://act.mgtv.com/favicon.ico';
        iframe.onload = () => {
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 0);
        };
        document.body.appendChild(iframe);
      }, 500);

      MgtvApi.setWebviewTitle({
        title: title
      });
    } else {
      setTimeout(() => {
        document.title = title;
        const iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.src = 'https://club.mgtv.com/favicon.ico';
        iframe.onload = () => {
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 0);
        };
        document.body.appendChild(iframe);
      }, 0);
    }

  } else {
    document.title = title;
  }
}
